// Literal values are a fixed wire contract with the almabox-launcher client — do not rename.
export type InstallationType = 'monitor' | 'projector';

export const INSTALLATION_TYPES: readonly InstallationType[] = ['monitor', 'projector'];
